import React from 'react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import PropTypes from 'prop-types';
import { Image, Divider, Icon } from 'semantic-ui-react';
import HowToCloseModal from '../../components/how-to-close-modal';

const wrapperStyle = {
  textAlign: 'center',
};

const DeleteInfluencerModal = ({
  onClose,
  campaignName,
  onConfirm,
  influencer: {
    thumbnail,
    influencerName,
  },
}) => (
  <DyzioModal
    headerText="Remove Influencer"
    size="small"
    onClose={onClose}
    hasActionButton
    actionButtonColor="red"
    actionButtonContent="Delete"
    actionButtonIcon={<Icon name="trash" />}
    onActionButtonClick={onConfirm}
  >
    <div style={wrapperStyle}>
      <Image src={thumbnail} centered className="circular" size="small" />
      <Divider hidden />
      <h3>Are you sure you want to remove {influencerName} from campaign {campaignName}?</h3>
      <HowToCloseModal />
    </div>
  </DyzioModal>
);

DeleteInfluencerModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  influencer: PropTypes.object.isRequired,
  campaignName: PropTypes.string.isRequired,
};

export default DeleteInfluencerModal;



/** WEBPACK FOOTER **
 ** ./src/components/delete-influencer-modal/index.js
 **/